<template>
    <div v-if="this.$store.getters.GetBlock.notifications"></div>    
    <div v-if="this.$store.getters.Loaded && this.$store.getters.GetBlock.orgcom" class="uk-container uk-container-center uk-text-center uk-margin-top uk-position-z-index-negative" style="background-image: none;">
        <h1 class="uk-heading" id="org_com">{{this.$store.getters.GetText.orgcom.title[this.$store.getters.Lang]}}</h1>
        <h2 class="uk-heading">{{this.$store.getters.GetText.orgcom.subtitle[this.$store.getters.Lang]}}</h2>
        <div class="uk-card uk-card-default uk-position-z-index-negative">
            <div class="uk-card-media-top">
                <img src="../assets/img/org/pred.jpg" width="250" height="300" alt="">
            </div>
            <div class="uk-card-body">
                <h3 class="uk-card-title">{{this.$store.getters.GetText.orgcom.name_pred[this.$store.getters.Lang]}}</h3>
                <h4>{{this.$store.getters.GetText.orgcom.position_pred[this.$store.getters.Lang]}}</h4>
            </div>
        </div>
        <ul uk-accordion>
            <li>
                <a class="uk-accordion-title uk-button uk-button-default" href="#">{{this.$store.getters.GetText.orgcom.sub_pred_title[this.$store.getters.Lang]}}</a>
                <div class="uk-accordion-content">
                    <ul v-html="this.$store.getters.GetText.orgcom.sub_preds[this.$store.getters.Lang]" class="uk-list">
                    </ul>
                </div>
            </li>
            <li>
                <a class="uk-accordion-title uk-button uk-button-default" href="#">{{this.$store.getters.GetText.orgcom.sec_title[this.$store.getters.Lang]}}</a>
                <div class="uk-accordion-content">
                    <ul v-html="this.$store.getters.GetText.orgcom.secretaries[this.$store.getters.Lang]" class="uk-list ">
                    </ul>
                </div>
            </li>
            <li>
                <a class="uk-accordion-title uk-button uk-button-default" href="#">{{this.$store.getters.GetText.orgcom.member_title[this.$store.getters.Lang]}}</a>
                <div class="uk-accordion-content">
                    <ul v-html="this.$store.getters.GetText.orgcom.	members[this.$store.getters.Lang]" class="uk-list ">                        
                    </ul>
                </div>
            </li>
        </ul>
    </div>
</template>